/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { InitiateSoftpayAppSwitchPaymentRequestTip } from './InitiateSoftpayAppSwitchPaymentRequestTip';
import {
    InitiateSoftpayAppSwitchPaymentRequestTipFromJSON,
    InitiateSoftpayAppSwitchPaymentRequestTipFromJSONTyped,
    InitiateSoftpayAppSwitchPaymentRequestTipToJSON,
    InitiateSoftpayAppSwitchPaymentRequestTipToJSONTyped,
} from './InitiateSoftpayAppSwitchPaymentRequestTip';

/**
 * 
 * @export
 * @interface InitiateSoftpayAppSwitchPaymentRequest
 */
export interface InitiateSoftpayAppSwitchPaymentRequest {
    /**
     * 
     * @type {number}
     * @memberof InitiateSoftpayAppSwitchPaymentRequest
     */
    amountMinorUnits: number;
    /**
     * 
     * @type {Currency}
     * @memberof InitiateSoftpayAppSwitchPaymentRequest
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof InitiateSoftpayAppSwitchPaymentRequest
     */
    executingLocationId: number;
    /**
     * 
     * @type {string}
     * @memberof InitiateSoftpayAppSwitchPaymentRequest
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateSoftpayAppSwitchPaymentRequest
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateSoftpayAppSwitchPaymentRequest
     */
    terminalId: string;
    /**
     * 
     * @type {InitiateSoftpayAppSwitchPaymentRequestTip}
     * @memberof InitiateSoftpayAppSwitchPaymentRequest
     */
    tip: InitiateSoftpayAppSwitchPaymentRequestTip;
}



/**
 * Check if a given object implements the InitiateSoftpayAppSwitchPaymentRequest interface.
 */
export function instanceOfInitiateSoftpayAppSwitchPaymentRequest(value: object): value is InitiateSoftpayAppSwitchPaymentRequest {
    if (!('amountMinorUnits' in value) || value['amountMinorUnits'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    if (!('tip' in value) || value['tip'] === undefined) return false;
    return true;
}

export function InitiateSoftpayAppSwitchPaymentRequestFromJSON(json: any): InitiateSoftpayAppSwitchPaymentRequest {
    return InitiateSoftpayAppSwitchPaymentRequestFromJSONTyped(json, false);
}

export function InitiateSoftpayAppSwitchPaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateSoftpayAppSwitchPaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amountMinorUnits': json['amountMinorUnits'],
        'currency': CurrencyFromJSON(json['currency']),
        'executingLocationId': json['executingLocationId'],
        'orderReference': json['orderReference'],
        'paymentReference': json['paymentReference'],
        'terminalId': json['terminalId'],
        'tip': InitiateSoftpayAppSwitchPaymentRequestTipFromJSON(json['tip']),
    };
}

export function InitiateSoftpayAppSwitchPaymentRequestToJSON(json: any): InitiateSoftpayAppSwitchPaymentRequest {
    return InitiateSoftpayAppSwitchPaymentRequestToJSONTyped(json, false);
}

export function InitiateSoftpayAppSwitchPaymentRequestToJSONTyped(value?: InitiateSoftpayAppSwitchPaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amountMinorUnits': value['amountMinorUnits'],
        'currency': CurrencyToJSON(value['currency']),
        'executingLocationId': value['executingLocationId'],
        'orderReference': value['orderReference'],
        'paymentReference': value['paymentReference'],
        'terminalId': value['terminalId'],
        'tip': InitiateSoftpayAppSwitchPaymentRequestTipToJSON(value['tip']),
    };
}

